import 'sharer.js'
import mediumZoom from 'medium-zoom'

mediumZoom('.wp-block-image > img', {
  scrollOffset: 0,
})
